import { COLORS } from 'helpers/globals'
import { list, third, listItem, selected } from 'components/CameraModelSelector/style'

const star = {
  color: COLORS.gold,
  fontSize: '1.9rem'
}

export default {
  ManufacturerList: {
    ...third
  },
  manufacturerName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    flex: 1
  },
  star,
  clock: {
    ...star,
    color: COLORS.secondary,
    marginRight: '.2rem'
  },
  selected: {
    ...selected,
    cursor: 'pointer'
  },
  listItem,
  list,
  showOtherManufacturers: {
    textAlign: 'center',
    fontSize: '2rem',
    marginTop: '1rem',
    cursor: 'pointer',
    textDecoration: 'underline'
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/ManufacturerList/style.js